enum MailActionType {
    REPLY = "reply",
    REPLY_ALL = "replyAll",
    FORWARD = "forward",
}

export default MailActionType;
